import { render, staticRenderFns } from "./ExistingEditor.vue?vue&type=template&id=ebb3a8c2&scoped=true&"
import script from "./ExistingEditor.vue?vue&type=script&lang=js&"
export * from "./ExistingEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb3a8c2",
  null
  
)

export default component.exports